'use client';

import { type ReactNode } from 'react';

import { NavItemCollapsingContext } from '../nav-item-collapsing-context';
import { usePrimaryNavRail } from './primary-nav-rail-context';
import { type PrimaryNavRailId } from './primary-nav-rail.constants';

interface PrimaryNavFixedItemProps {
  id: PrimaryNavRailId;
  children: ReactNode;
}

/**
 * Renders children only when the item has not committed its collapse.
 * While an item is animating out (collapsingIds), it stays mounted and
 * NavItemCollapsingContext signals NavItem to play the height-collapse
 * animation inside the <li> — keeping the DOM valid (ul > li > div > button).
 */
export function PrimaryNavFixedItem({ id, children }: PrimaryNavFixedItemProps) {
  const { collapsedIds, collapsingIds } = usePrimaryNavRail();
  if (collapsedIds.has(id)) return null;
  return (
    <NavItemCollapsingContext.Provider value={collapsingIds.has(id)}>
      {children}
    </NavItemCollapsingContext.Provider>
  );
}
